// This should match the version in package.json or else it will break the CI workflow
// You should not need to manually update this value, it will be managed using `pnpm version:sync` during release creation
export const VERSION = '0.5.0';
